import React, { useEffect, useState } from "react";
import AppMobile from "./srcMobile/App";
import AppWeb from "./srcWeb/App";
import AppAdminWeb from "./srcAdminWeb/src/App";
import AdminWebTheme from "./srcAdminWeb/ThemeSelector";
import AppWebTheme from "./srcWeb/components/ThemeSelector"
import { getItem, removeItem } from "./srcWeb/utils/localStorage";
import { useLocation } from "react-router-dom";

const App = () => {
  const subDomainRoute = (sub) => {
    // switch (sub) {
    if (sub == "admin") {
      return (
        <AdminWebTheme cssConfig={sub}>
          <AppAdminWeb />
        </AdminWebTheme>
      );
    } else {
      return (
        <AppWebTheme cssConfig={sub}>
          <AppWeb />
        </AppWebTheme>
      );
    }
    //   // case "salesrec":
    //   //   return <NavbarIndex/>
    //   //   break;

    //   // case "admin":
    //   //   return <AdminApp/>
    //   //   break;

    //   // default:
    //   //   return <div>Something Went Wrong</div>
    //   //   break;
    //   // }
  };
  return window.innerWidth <= 480 ? (
    <AppMobile />
  ) : (
    <>
      {/* <AppWeb /> */}
      {subDomainRoute(window.location.pathname.split("/")[1] || "")}
    </>
  );
};

export default App;
